module.exports = __webpack_public_path__ + "static/media/folder-with-eyeglass.a59352a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/folder-with-eyeglass.svg
// module id = 173
// module chunks = 0